module.exports = __webpack_public_path__ + "static/media/template.9dab9246.svg";